module.exports = __webpack_public_path__ + "img/1.f9967da8.webp";